import template from 'text!./button.html';

export default [function () {
    return {
        restrict: 'E',
        replace: true,
        template: template,
        transclude: true,
        scope: {
            onClick: '&',
            icon: '@',
            disabled: '<',
            flavor: '@'
        },
        link: function link(scope, element, attrs) {
            scope.primary = 'primary' in attrs;
            scope.isIconSort = function () {
                return scope.icon === 'sort-desc';
            };
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/atomic_design/button/button.js
// module id = 1019
// module chunks = 0